<template>
  <BaseDialog
    v-model="opened"
    close
    content-width="600px"
  >
    <BaseCard class="m_pa16 m_bg-white m_flex m_flex-column m_flex-grow1 m_hov-elevation-1 m_hov-border-none">
      <p class="m_h2 m_mb16">
        Успейте сделать заказ до 17.12 и сможете забрать заказ до нового года.
      </p>
      <p class="m_h4">
        Заказы сделанные после 17.12 будут обработаны уже после нового года
      </p>
    </BaseCard>
  </BaseDialog>
</template>

<script setup lang="ts">
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const opened = ref(false);

const route = useRoute();
const duration = (route.name === 'Catalog' || route.name === 'Products') ? 5000 : 10000;
const dateLimit = new Date('2026-01-12T00:00:00') > new Date();

setTimeout(() => {
  if (route.name !== 'GetCard' && dateLimit) {
    opened.value = true;
  }
}, duration);
</script>
